import defaultTo from 'lodash/defaultTo';

import { ConvertibleFilingTalkRanges } from '../../../../../../../../common/hooks/useConvertibleFilingTalkRanges';
import { OfferingType } from '../../../../../../../../graphql';
import { BuySideIndicationQuery } from '../../../../context/hooks/buy-side/__generated__';
import { getInterestLevelOrderType } from '../../common/indication-section-form/IndicationSectionForm.model';
import {
  emptyInterestLevelValue,
  IndicationFormValues,
} from '../../common/utils/IndicationSectionValidation';

type CreateInitialValuesParams = {
  offeringType: OfferingType | null;
  indication: BuySideIndicationQuery['basicPublishedOffering']['myInstitutionalIndication'];
  convertibleFilingTalkRanges: ConvertibleFilingTalkRanges;
  isIndicationPriceAsPercentageParEnabled: boolean;
};

export const createInitialValues = ({
  indication,
  convertibleFilingTalkRanges,
  offeringType,
  isIndicationPriceAsPercentageParEnabled,
}: CreateInitialValuesParams): IndicationFormValues => {
  const interestLevels =
    indication?.interestLevels.map(
      ({
        interestQuantity,
        interestUnit,
        limitType,
        limitPrice,
        coupon,
        premium,
        percentageOfPar,
      }) => ({
        interestQuantity,
        interestUnit,
        orderType: getInterestLevelOrderType({
          interestLevel: {
            coupon,
            premium,
            limitPrice,
          },
          offeringType: offeringType,
          convertibleFilingTalkRanges,
          isIndicationPriceAsPercentageParEnabled,
        }),
        limitPrice: defaultTo(limitPrice, null),
        limitType: defaultTo(limitType, null),
        coupon: defaultTo(coupon, null),
        premium: defaultTo(premium, null),
        percentageOfPar: defaultTo(percentageOfPar, null),
      })
    ) ?? [];

  return {
    trancheId: indication?.trancheId ?? null,
    instrumentId: indication?.instrumentId ?? null,
    currencyCode: indication?.currencyCode ?? null,
    selectedInterestUnit: interestLevels[0]?.interestUnit ?? null,
    interestLevels: interestLevels.length > 0 ? interestLevels : [emptyInterestLevelValue],
  };
};
